export enum TrialTypes {
  Annals = 'annals',
  ContentPDF = 'contentPDF',
  DimensionTest = 'dimensionTest',
  Essential = 'essential',
  Post = 'post',
  PracticeCorrectionPDF = 'practiceCorrectionPDF',
  PracticeSubjectPDF = 'practiceSubjectPDF',
  PracticeToolkitPDF = 'practiceToolkitPDF',
  Quiz = 'quiz',
  Result = 'result',
  Practice = 'practice',
  Pairing = 'pairing',
  Course = 'course',
}

export enum Constant {
  PARAMETERS_PATHS = 'parametersPaths',
  MyFuture = 'MyFuture',
}

export enum LockStates {
  Default = 'default',
  Locked = 'locked',
  Unlocked = 'unlocked',
}

export enum ContentTypes {
  Menu = 'menu',
  Home = 'home',
  Adventure = 'adventure',
  CourseAndQuiz = 'course&quiz',
  Chapter = 'chapter',
  SubChapter = 'sub-chapter',
  Training = 'training',
  Annals = 'annals',
  Exam = 'exam',
  Testing = 'testing',
  Essential = 'essential',
  DimensionTest = 'dimensionTest',
  Discipline = 'discipline',
  Extra = 'extra',
  SuperDiscipline = 'super-discipline',
  InterDiscipline = 'inter-discipline',
  SubDiscipline = 'sub-discipline',
  DisciplineSection = 'discipline-section',
  DisciplineSubSection = 'discipline-sub-section',
  Practice = 'practice',
  Favorite = 'favorite',
  Championship = 'championship',
  Result = 'result',
  GlobalResult = 'globalResult', // Used for bilan of Test d'Orientation
  SecondaryMenu = 'secondarymenu',
  Partners = 'partners',
  NomadPlus = 'library',
  Family = 'family',
  Calendar = 'calendar',
  Profile = 'profile',
  SponsorInfo = 'sponsors',
  About = 'about',
  Share = 'share',
  Rate = 'apprating',
  Header = 'header',
  Instructions = 'instructions',
  VideoRecorder = 'video_recorder',
  VideoRecorderResult = 'video_recorder_result',
  InterDisciplineInfoIntox = 'inter-discipline-infoIntox',
  InterDisciplineDailyQuiz = 'inter-discipline-dailyQuiz',
  InterDisciplineActu = 'inter-discipline-actu',
  InterDisciplineFocusOn = 'inter-discipline-focusOn',
  InterDisciplineOther = 'inter-discipline-other',
  Assessment = 'assessment',
}

export type ContentTypesType = typeof ContentTypes;

export enum ChildTypes {
  Category = 'category',
  Post = 'post',
  Quiz = 'quiz',
  Test = 'test',
  Annals = 'annals',
  SponsorInfo = 'sponsorinfo',
  Event = 'event',
  Exercise = 'exercise',
}

export enum PostTypes {
  course = 'course',
  CourseVideo = 'course_video',
  News = 'news',
  Subject = 'subject',
  Correction = 'correction',
  CorrectionPDF = 'correctionPDF',
  Instructions = 'instructions',
  ContentPDF = 'contentPDF',
  ResultAnalysis = 'result_analysis',
  ResultSkills = 'result_skills',
  ResultDomains = 'result_domains',
  Practice = 'practice',
  PracticeSubjectPDF = 'practiceSubjectPDF',
  PracticeCorrectionPDF = 'practiceCorrectionPDF',
  PracticeToolkitPDF = 'practiceToolkitPDF',
  ExpressCorrection = 'expressCorrection',
}

export type PostTypesType = typeof PostTypes;

export interface Customer {
  sponsorId?: string;
  webLink?: string;
  color?: string;
  media?: string;
  baseline?: string;
  customerSponsorId?: string;
  customerWebLink?: string;
  customerColor?: string;
  customerMedia?: string;
  customerBaseline?: string;
}

export enum LibraryContentTypes {
  LibraryBook = 'librarybook',
  LibraryBox = 'librarybox',
}

export enum LibraryTypes {
  Default = 'default',
  Shelf = 'shelf',
  FreeLibraryRootBox = 'freeLibraryRootBox',
  RootBox = 'rootBox',
  MediaBox = 'mediabox',
}

export enum SlugTypes {
  SponsorForm = 'sf',
  LibraryBox = 'lx',
  Post = 'pt',
  CatalogApp = 'ca',
  Form = 'fm',
  SponsorInfo = 'si',
  App = 'lb',
  Question = 'qn',
  Job = 'jb',
  Category = 'cy',
  Quiz = 'qz',
  MyFutureBox = 'fb',
}

export enum CollectionTypes {
  Categories = 'categories',
  Posts = 'posts',
  Quizzes = 'quizzes',
  Media = 'media',
  Challenges = 'challenges',
  Library = 'library',
  LibraryBooks = 'libraryBooks',
  Progressions = 'progressions',
  Trophies = 'trophies',
  Questions = 'questions',
  CoachingStats = 'coachingStats',
  QuizInfos = 'quizInfos',
  Assessments = 'assessments',
  ExerciseInfos = 'exerciseInfos',
  Exercises = 'exercises',
  ExerciseItems = 'exerciseItems',
  Recommendations = 'recommendations',
  RecommendationParameters = 'recommendationParameters',
  Friends = 'friends',
  MyFutureBoxes = 'myFutureBoxes',
  SponsorInfos = 'sponsorInfos',
  Sponsors = 'sponsors',
  Events = 'events',
}

export enum URI {
  AppConfigurations = '/appconfigurations',
  Users = '/users',
  MySelf = '/myself',
  Profile = '/profile',
  Trophies = '/membertrophies',
  Library = '/libraryv2',
  LibraryBooks = '/librarybooks',
  Challenges = '/adaptiveChallenges',
  Progressions = '/progressionsV2',
  MultiProgressions = '/multi-progressionsv2',
  ShouldSync = '/shouldSync',
  Categories = '/categories',
  Quizzes = '/quizzes',
  Exercises = '/exercises',
  Posts = '/posts',
  Media = '/media',
  AddAppIds = '/members/updateAddedAppIds',
  MemberProfile = '/memberProfile',
  MultiAppEvents = '/multi-appevents',
  JoinFamily = '/joinAFamily', // POST /joinAFamily  param : {"code": <code>}
  UpdateFamily = '/updateFamily', // POST /updateFamily param : {"avatar": <avatarMediaId>}
  SendParentEmail = '/sendParentEmail', // POST {"email": <email du parent>, "template": <solo|family>}  /// Le template c'est selon si le parent est invité par l'enfant à prendre un abo depuis la page famille (family) ou depuis un contenu bloqué (solo)
  RemoveFromFamily = '/removeFromFamily', // POST /removeFromFamily param : {"memberId": <id du membre de la famille à supprimer>}.   /// Seulement pour l'admin de la famille
  ContentLimit = '/contentLimit',
  Profiling = '/profilingNextStep',
  AddFamilyPlaceholderMember = '/addFamilyPlaceholderNextStep',
  UpdateFamilyPlaceholderMember = '/updateFamilyPlaceholderNextStep',
  CreateAFamily = '/createAFamily',
  UpdateUserProfiling = '/updateUserProfiling',
  MemberPreferences = '/memberPreferences',
  UpdatePreferences = '/updatePreferences',
  DeleteAccount = '/deleteAccount',
  UpdateUserProfilingForm = '/updateUserProfilingForm',
  Referral = '/referral',
  ReferralVerify = '/referral/verify', // GET ?referalCode=xxxx => isValid: boolean
  SignupForm = '/signup-form',
  SignupSend = '/auth/local/register',
  ForgotPasseword = '/forgot',
  Reset = '/reset',
  StripeManage = '/stripe/manage',
  Gaming = '/gaming',
  GamingUseBonus = '/gaming/useBonus',
  CoachingStats = '/coachingstats',
  CoachingObjectives = '/objectives',
  Assessments = '/assessments',
  MultiAssessments = '/multi-assessments', // ForYou_Assessments_PostMultiple
  AssessmentsDeleteByUuid = 'assessments/deleteByUuid',
  Favorites = '/favorites',
  GradeSimulator = '/gradeSimulator',
  MemberGrades = '/memberGrades',
  Feed = '/feed',
  FeedReadIds = '/feed/readIds',
  Recommendations = '/computedRecommendation',
  MemberRecommendationParameters = '/memberRecommendationParameters',
  MultiMemberRecommendationParameters = '/multi-memberRecommendationParameters',
  Friend = '/friend',
  FriendSearch = '/friend/search',
  FriendSuggestion = '/friend/suggestion',
  MyFuture = '/myfuturev2',
  ProfileAction = '/profile/action',
  ConfirmLeadData = '/confirmLeadData',
}

export enum EventAssociatedModel {
  Assessment = 'Assessment',
  Exercise = 'Exercise',
  ExerciseItem = 'ExerciseItem',
  Action = 'Action',
  Session = 'WorkingSession',
  Post = 'Post',
  Quiz = 'Quiz',
  Question = 'Question',
  Challenge = 'Challenge',
  Essential = 'Essentials',
  Annal = 'Annals',
  GradeSimulator = 'GradeSimulator',
  SponsorInfo = 'SponsorInfo',
  MyFutureBox = 'MyFutureBox',
  Gad = 'GAD',
  LibraryBox = 'LibraryBox',
  Share = 'Share',
  Subscription = 'Subscription',
  View = 'View',
  NomadPlus = 'NomadPlus',
  Feed = 'Feed',
  Recommendation = 'Recommendation',
  Friend = 'Friend',
  ContentLockScreen = 'ContentLockScreen',
}

export enum EventAssessment {
  AddStarted = 'addStarted',
  StepDisciplineConfirmed = 'stepDisciplineConfirmed',
  StepChaptersConfirmed = 'stepChaptersConfirmed',
  StepDateConfirmed = 'stepDateConfirmed',
  AddCompleted = 'addCompleted',
  Opened = 'opened',
}

export enum EventSession {
  Start = 'SessionStart',
  Stop = 'SessionStop',
}

export enum EventFeed {
  ActionClicked = 'actionClicked',
}

export enum EventQuiz {
  Started = 'quizStarted',
  Ended = 'quizEnded',
  Left = 'quizLeft',
}

export enum EventExercise {
  Started = 'exerciseStarted',
  Ended = 'exerciseEnded',
  Left = 'exerciseLeft',
  ExerciseAsParentBottomSheetTrialOpened = 'exerciseAsParentBottomSheetTrialOpened',
  ExerciseAsParentBottomSheetAccountSwitched = 'exerciseAsParentBottomSheetAccountSwitched',
  ExerciseAsParentBottomSheetShared = 'exerciseAsParentBottomSheetShared',
  ExerciseAsParentBottomSheetCorrectionOpened = 'exerciseAsParentBottomSheetCorrectionOpened',
}

export enum EventSponsorInfo {
  MainPageViewed = 'mainPageViewed',
  EndVisit = 'endVisit',
  WebsiteViewed = 'websiteViewed',
  VideoViewed = 'videoViewed',
  EventsViewed = 'eventsViewed',
  CategoryViewed = 'categoryViewed',
  RequestWhatsAppClicked = 'requestWhatsAppClicked',
  RequestCalledClicked = 'requestCalledClicked',
  RequestBrochureClicked = 'requestBrochureClicked',
  SchoolBasketSponsorInfoViewed = 'schoolBasketSponsorInfoViewed',
  MonAvenirSponsorInfoViewed = 'monAvenirSponsorInfoViewed',
  CategoryCustomerClicked = 'categoryCustomerClicked',
  ShareClicked = 'shareClicked',
}

export enum EventRecommendation {
  ChapterRecommendationsShown = 'chapterRecommendationsShown',
  ChapterExerciseWithErrorListOpened = 'chapterExerciseWithErrorListOpened',
  ChapterExerciseWithErrorStarted = 'chapterExerciseWithErrorStarted',
  ChapterAdaptiveRecommendationStarted = 'chapterAdaptiveRecommendationStarted',
}

export enum EventFriend {
  FriendHomePopupViewed = 'friendHomePopupViewed',
  FriendHomePopupOpenClicked = 'friendHomePopupOpenClicked',
  FriendHomePopupCloseClicked = 'friendHomePopupCloseClicked',
  FriendPageViewed = 'friendPageViewed',
  FriendListPageViewed = 'friendListPageViewed',
  FriendFeedPageViewed = 'friendFeedPageViewed',
  FriendAddPageViewed = 'friendAddPageViewed',
  FriendAddPageInvitationShareClicked = 'friendAddPageInvitationShareClicked',
  FriendAddPageInvitationQRCodeClicked = 'friendAddPageInvitationQRCodeClicked',
  FriendAddPageSearchClicked = 'friendAddPageSearchClicked',
  FriendAddPageSuggestionsTabClicked = 'friendAddPageSuggestionsTabClicked',
  FriendAddPageContactsTabClicked = 'friendAddPageContactsTabClicked',
  FriendAddPageAddSuggestionClicked = 'friendAddPageAddSuggestionClicked',
  FriendAddPageInviteContactClicked = 'friendAddPageInviteContactClicked',
  FriendDetailPageClicked = 'friendDetailPageClicked',
  FriendDetailPageFriendshipInvitationChosen = 'friendDetailPageFriendshipInvitationChosen',
  FriendDetailPageFriendshipRemoved = 'friendDetailPageFriendshipRemoved',
  FriendDetailPageMutualFriendsOpened = 'friendDetailPageMutualFriendsOpened',
}

export enum EventExerciseItem {
  ItemViewed = 'itemViewed',
  AnswerSubmitted = 'answerSubmitted',
}

export enum EventChallenge {
  Started = 'challengeStarted',
  Ended = 'challengeEnded',
  Left = 'challengeLeft',
}

export enum EventNomadPlus {
  OnBoardingParentViewed = 'onBoardingParentViewed',
  OnBoardingParentSubscribeClicked = 'onBoardingParentSubscribeClicked',
  OnBoardingParentMoreInfosClicked = 'onBoardingParentMoreInfosClicked',
  OnBoardingParentCancelClicked = 'onBoardingParentCancelClicked',
}

export enum EventQuizQuestion {
  QuestionViewed = 'questionViewed',
  AnswerSubmitted = 'answerSubmitted',
  CorrectionEnd = 'correctionEnd',
  CorrectionViewed = 'correctionViewed',
}

export enum EventPost {
  Visited = 'postVisited',
  Ended = 'postEnded',
}

export enum EventLibraryBox {
  Clicked = 'boxClicked',
}

export enum EventView {
  Discipline = 'discipline',
  NomadPlus = 'nomadPlus',
  Deeplink = 'deeplink',
  Category = 'category',
  Feed = 'feed',
}

export enum EventShare {
  ShareClicked = 'shareClicked',
  ShareCompleted = 'shareCompleted',
}

export enum ChallengeSteps {
  Beginner = 'Débutant',
  Amateur = 'Amateur',
  Regular = 'Habitué',
  Pro = 'Pro',
  Expert = 'Expert',
}

export interface FormFieldOption {
  name: string;
  value: string;
  iconUrl?: string;
  iconDoNotForceColorization?: boolean;
  subfield?: any;
}

export interface LabelLink {
  type: string;
  id: string;
}

export interface FormField {
  name: string;
  validation: any[];
  template: string;
  type: string;
  label?: string;
  memberValue?: any;
  options?: FormFieldOption[];
  multiple?: boolean;
  autocomplete?: any;
  readonly?: boolean;
  config?: any;
  values: any;
  labelLinks: LabelLink[];
}

export interface FormValidation {
  applyRule: boolean;
  validated: boolean;
  message?: string;
  messages?: string[];
}

export interface Coaching {
  objectiveMinutesPerWeek?: number;
  totalInMinutes?: number;
  totalInMinutesThisWeek?: number;
}

export enum NotificationTypes {
  Trophies = 'Trophies',
}

export enum AdamHeader {
  NomadTrophies = 'nomad-trophies',
  NomadLowPrioTrophies = 'nomad-low-prio-trophies',
  NomadGamingLevel = 'nomad-gaming-level',
  NomadGamingStreak = 'nomad-gaming-streak',
  NomadGamingXp = 'nomad-gaming-xp',
  NomadGamingAutomaticBonus = 'nomad-gaming-automaticbonus',
  NomadGamingAutomaticBonusId = 'id',
  NomadGamingAutomaticBonusExpiresAt = 'expires_at',
  NomadGamingReachedNewLevel = 'nomad-gaming-new-level',
  NomadGamingReachedNewLevelWithLowPriority = 'nomad-gaming-new-level-low-prio',
  NomadGamingReachedNewStreak = 'nomad-gaming-new-streak',
}

export enum ChapterChildrenTypes {
  Course = 'course',
  CourseVideo = 'course_video',
  Essential = 'essential',
  Multi = 'multi',
  Pairing = 'pairing',
  Fillblank = 'fillblank',
  Quiz = 'quiz',
  Flashcard = 'flashcard',
  Practice = 'practice',
  Annals = 'annals',
}

export const TrainingChapterChildrenTypes = [
  ChapterChildrenTypes.Flashcard,
  ChapterChildrenTypes.Quiz,
  ChapterChildrenTypes.Fillblank,
  ChapterChildrenTypes.Pairing,
  ChapterChildrenTypes.Multi,
  ChapterChildrenTypes.Practice,
  ChapterChildrenTypes.Annals,
];

export const RevisionChapterChildrenTypes = [
  ChapterChildrenTypes.Course,
  ChapterChildrenTypes.CourseVideo,
  ChapterChildrenTypes.Essential,
];

export interface GradeSimulatorFormDataDiscipline {
  id: string;
  label: string;
  coeff?: number;
  maxValue: number;
  required: boolean;
  memberValue?: number;
  options?: { label: string; value: number }[];
  optionsLabel?: string;
  displayMaxValue?: boolean;
}
export interface GradeSimulatorFormDataSubSection {
  title: string;
  color: string;
  disciplines: GradeSimulatorFormDataDiscipline[];
}
export interface GradeSimulatorFormDataSection {
  title: string;
  subSections: GradeSimulatorFormDataSubSection[];
}
export interface GradeSimulatorFormData {
  id: string;
  title: string;
  scoreColumnLabel: string;
  coeffColumnLabel: string;
  validateButtonLabel: string;
  sections: GradeSimulatorFormDataSection[];
}

export enum SponsorInfoTypes {
  SponsorInfoBrochure = 'sponsorinfo_brochure',
  SponsorInfoPhone = 'sponsorinfo_phone',
  SponsorInfoWhatsApp = 'sponsorinfo_whatsapp',
  SponsorInfoSchoolBasket = 'sponsorinfo_schoolbasket',
  SponsorInfoEvent = 'event',
}

export enum SponsorInfoEngagementSources {
  Event = 'event',
  Phone = 'sponsorinfo',
  Brochure = 'brochure',
  WhatsApp = 'whatsapp',
  SchoolBasket = 'schoolBasket',
}

export interface SponsorInfoEngagement {
  date: string;
  formationId?: string;
  campusId?: string;
  source: SponsorInfoEngagementSources;
}

export enum MyFutureBoxDisplayTypes {
  SmallSlider = 'smallSlider',
  SponsorInfoList = 'sponsorInfoList',
  LargeSlider = 'largeSlider',
  BoxButtons = 'boxButtons',
  SpecialOpList = 'specialOpList',
  Root = 'root',
  Default = 'default',
  ActionButtons = 'actionButtons',
}

export enum MyFutureBoxContentTypes {
  SponsorInfo = 'sponsorInfo',
  MyFutureBox = 'myFutureBox',
}
